(function() {
  'use strict';
  angular.module('dso', [
    'ngResource',
    'dnErrorDisplay',
    'common',
    'ui.bootstrap',
    'angularFileUpload',
    'ngFileSaver'
  ]);
})();
